module.exports = __webpack_public_path__ + "img/NewUserIcon.183bf593.svg";